import { action, makeObservable, observable } from 'mobx';
import { useEffect } from 'react';
import { API } from '~/api';
import { FragranceId } from '~/api/api.declaration';
import { ApiService } from '~/service/service.api';
import { Model } from '~/shared/service/service.base';
import { Async } from '~/shared/tools/async';
import { FeedbackDrawerModel } from './model.feedback.drawer';

@Model()
export class FragranceSuggestionsModel {
	private fragranceId?: FragranceId;

	@observable data = [] as API.Feedback[];
	@observable total = 0;
	@observable offset = 0;

	readonly limit = 20;
	readonly async = new Async();
	readonly drawer;

	constructor(private api: ApiService) {
		makeObservable(this);
		this.drawer = new FeedbackDrawerModel(this.api, this.reload);
	}

	use = (fragranceId: FragranceId) => {
		this.fragranceId = fragranceId;
		useEffect(() => this.reload(), []);
	};

	fetchNextPage = () => {
		const { fragranceId, limit, offset, total, async } = this;
		if (!fragranceId || async.loading) return;
		if (!total || offset >= total) return;

		this.async.call(async () => {
			const { data } = await this.api.feedbackGetFragranceSuggestions(fragranceId, { limit, offset });
			return () => {
				this.data = [...this.data, ...data.items];
				this.offset += this.limit;
			};
		});
	};

	@action.bound reload() {
		this.offset = 0;
		const { fragranceId, limit, offset } = this;
		if (!fragranceId) return;
		this.async.call(async () => {
			const { data } = await this.api.feedbackGetFragranceSuggestions(fragranceId, { limit, offset });
			return () => {
				this.data = data.items;
				this.total = data.total;
				this.offset = this.limit;
			};
		});
	}
}
